enum OrganizationType {
  SUPPLY = 'supply',
  DEMAND = 'demand',
  CURATOR = 'curate',
  EXCHANGE = 'exchange', // Not technically an organization type, but it's used in the same context during the organization selection.
  SIDEKICK = 'sidekick', // Not technically an organization type, but it's used in the same context during the organization selection.
  SUPPLY_PARENT = 'supply-parent',
  DEMAND_PARENT = 'demand-parent',
}

export default OrganizationType;
